/* eslint-disable max-len */
import React from "react";

interface DecorativeEmptyProps {
  width?: string;
  height?: string;
  color?: string;
  testId?: string;
}

export const DecorativeEmpty: React.FC<DecorativeEmptyProps> = ({ width = "96", height = "96", color = "#3A76BA", testId = "decorativeEmpty" }) => {
  return (
    <svg width={ width } height={ height } viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={ testId }>
      <rect width="96" height="96" rx="48" fill="#E9F3FF"/>
      <path opacity="0.3" d="M55.96 58.7998H33.6201V36.46L55.96 58.7998ZM65.6201 38.7998V57.1396L47.96 38.7998H65.6201Z" fill={ color }/>
      <path d="M69.4004 66.5996L66.5801 69.4199L59.96 62.7998H33.6201C31.4201 62.7998 29.6201 60.9998 29.6201 58.7998L29.6396 34.7998C29.6397 34.12 29.8202 33.5003 30.1201 32.9404L27 29.8203L29.8203 27L69.4004 66.5996ZM45.6201 30.7998L49.6201 34.7998H65.6201C67.82 34.7999 69.62 36.5999 69.6201 38.7998V58.7998C69.6201 59.4798 69.4396 60.1002 69.1396 60.6602L65.6201 57.1396V38.7998H47.96L39.96 30.7998H45.6201ZM33.6201 58.7998H55.96L33.6201 36.46V58.7998Z" fill={ color }/>
    </svg>
  );
};
